"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBetweenDates = exports.matchWeekdayHoliday = exports.IsoDaysOfWeek = exports.dayOfWeekAsString = exports.days = void 0;
const moment_1 = __importDefault(require("moment"));
exports.days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
];
function dayOfWeekAsString(dayIndex) {
    return exports.days[dayIndex - 1];
}
exports.dayOfWeekAsString = dayOfWeekAsString;
const translatedDayOfWeekAsString = (dayIndex, t) => {
    return ([
        "",
        t("availability.monday"),
        t("availability.tuesday"),
        t("availability.wednesday"),
        t("availability.thursday"),
        t("availability.friday"),
        t("availability.saturday"),
        t("availability.sunday"),
    ][dayIndex] || "");
};
exports.default = translatedDayOfWeekAsString;
exports.IsoDaysOfWeek = [1, 2, 3, 4, 5, 6, 7];
function matchWeekdayHoliday(day, holidays, filter, dateMillisec) {
    let m = null;
    if (dateMillisec) {
        m = (0, moment_1.default)(dateMillisec);
    }
    else {
        m = moment_1.default.tz(day.tz);
        // If m.weekday > day.n, then day.n is in the past. Set m to isoWeekday n and push it forward into the next week.
        m = (m.isoWeekday() > day.n) ? m.isoWeekday(day.n).add(1, "weeks") : m.isoWeekday(day.n);
    }
    let matchServiceHolidayDate = false;
    const isMomentHoliday = (holiday) => moment_1.default.tz(holiday.date, "MM-DD-YYYY", day.tz).isSame(m, "day");
    const isMomentServiceHoliday = (holiday) => {
        if (holiday.serviceHoliday && moment_1.default.tz(holiday.serviceHoliday, "MM-DD-YYYY", day.tz).isSame(m, "day")) {
            return (matchServiceHolidayDate = true);
        }
    };
    const foundHoliday = holidays === null || holidays === void 0 ? void 0 : holidays.find(day => isMomentServiceHoliday(day) || isMomentHoliday(day));
    const result = foundHoliday ? ({ holiday: foundHoliday,
        matchedServiceHoliday: matchServiceHolidayDate }) : undefined;
    if (result && (!filter || filter(result)))
        return result;
}
exports.matchWeekdayHoliday = matchWeekdayHoliday;
function isBetweenDates(date, startHr, endHr, tz) {
    return moment_1.default.tz(date, "MM-DD-YYYY", tz).isBetween(moment_1.default.tz(startHr, tz), moment_1.default.tz(endHr, tz));
}
exports.isBetweenDates = isBetweenDates;
